<p [hidden]="previousRemito === true || isVehicle === true">El remito {{rmtNum}} ha sido generado</p>
<p [hidden]="previousRemito === false">El remito {{rmtNum}} ha sido actualizado</p>
<p *ngIf="isVehicle == true">Remito {{rmtNum}} Creado. Correo Enviado a la Impresora {{impresora}}</p>
<div style="text-align:center;" *ngIf="!isBalanzaOrVehicle()" >
  <app-print-email-remitos-button [type]="'print'"
                                  [remitos]="[{ptoEmision: ptoEmision, nroRemito: rmtNum}]"></app-print-email-remitos-button>
  <app-print-email-remitos-button [type]="'email'"
                                  [remitos]="[{ptoEmision: ptoEmision, nroRemito: rmtNum}]"></app-print-email-remitos-button>
</div>
<br>
<div style="text-align:center;">
    <button class="delete-button" mat-button [mat-dialog-close]>Ok</button>
</div>
